import { useState, useEffect, useRef } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { signOut } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { APP_PATHS } from '../../../routes/paths';
import { authSelectors } from 'store/selectors';

const useSessionTimeout = () => {
	const INITIAL_TIMER = 20;
	const IDLE_TIMEOUT =
		process.env.NODE_ENV === 'development' ? 10 * 60 * 1000 : 60 * 1000;
	const dialogInterval = useRef(0);
	const [counter, setCounter] = useState(INITIAL_TIMER);
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const dispatch = useDispatch();
	let history = useHistory();
	const { START } = APP_PATHS;

	const isAuthenticated = useSelector(authSelectors.isAuthenticated);
	const { pathname } = useLocation();
	const isHomePage = pathname === START;

	const handleSignOut = async () => await signOut()(dispatch);

	const handleOnIdle = () => {
		if (isAuthenticated || !isHomePage) {
			if (!isDialogOpen) {
				setIsDialogOpen(true);
				setCounter(INITIAL_TIMER);

				const currentInterval = setInterval(() => {
					setCounter((c) => c - 1);
				}, 1000);

				dialogInterval.current = currentInterval;
			}
		}
	};

	useIdleTimer({
		timeout: IDLE_TIMEOUT,
		onIdle: handleOnIdle,
	});

	const handleClose = () => {
		setIsDialogOpen(false);
		clearInterval(dialogInterval.current);
	};

	const handleResetApp = async () => {
		clearInterval(dialogInterval.current);
		setIsDialogOpen(false);
		isAuthenticated && (await handleSignOut());
		history.push(START);
	};

	useEffect(() => {
		counter === 0 && handleResetApp();
		// eslint-disable-next-line
	}, [counter]);

	return {
		isDialogOpen,
		counter,
		handleClose,
		handleResetApp,
	};
};

export default useSessionTimeout;
